module.exports = __webpack_public_path__ + "img/download.7a8cb8fc.svg";